import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// pages
import Header from './header';
import Footer from './footer';
import Main from './main';
import NotFound from './404';
import CringeLounge from './cringe-lounge';
import NewSite from './new-site';
import PrivacyPolicy from './privacy-policy';
import AccountPage from './account';
import SettingsPage from './settings';
//components
import Logout from './components/logout';
import ToastViewport from './components/ToastViewport';
// scripts
import './scripts/scroll';
import './scripts/headerMenu';
import './scripts/themeSwitch';
import './scripts/new-site-qa';
import './scripts/profileMove';
import './scripts/profileMenu';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
            <Header />
            <ToastViewport />
            <div className="content">
              <Routes>
                <Route path="/" element={<Navigate to="/main" />} />
                <Route path="/main" element={<Main />} />
                {/* Uncomment and add the necessary imports for these routes */}
                <Route path="/cringe-lounge" element={<CringeLounge />} />
                {/* <Route path="/new-site" element={<AboutPage />} /> */}
                <Route path="/new-site" element={<NewSite />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/logout" element={<Logout />} />
              </Routes>
            </div>
            <Footer />
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
